module.exports = __webpack_public_path__ + "static/government_card-387bbba22833584ff22fdc187754fc7f.png";